export default __webpack_public_path__ + "static/modzele-4f55d3e4b3a29658f2a55df6af6dc6c2.png";